module.exports = __webpack_public_path__ + "assets/new-green-checkmark.cae2c6c5.svg";